import { render, staticRenderFns } from "./ShowPropertyStatusDetails.vue?vue&type=template&id=5ffa8e01&scoped=true&"
import script from "./ShowPropertyStatusDetails.vue?vue&type=script&lang=js&"
export * from "./ShowPropertyStatusDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShowPropertyStatusDetails.vue?vue&type=style&index=0&id=5ffa8e01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa8e01",
  null
  
)

export default component.exports